<template>
  <div>
    <v-text-field
      v-model="localData"
      outlined
      :label="name"
      :readonly="readonly"
      :disabled="disabled"
    ></v-text-field>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'Input',

  model: {
    prop: 'data'
  },

  props: {
    data: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    localData: null
  }),

  computed: {},

  watch: {
    localData: {
      deep: true,
      handler: 'setTranslation'
    },
    data: {
      deep: true,
      handler() {
        if (JSON.stringify(this.data) === JSON.stringify(this.localData)) {
          return;
        }
        this.setData();
      }
    }
  },

  created() {},

  methods: {
    setData() {
      this.localData = cloneDeep(this.data);
    },
    setTranslation() {
      this.$emit('input', this.localData);
    }
  }
};
</script>
